!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (n, r) {
  return i = {}, o.m = c = {
    0: function (e, t) {
      e.exports = n;
    },
    1: function (e, t) {
      e.exports = r;
    },
    678: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return o;
      });
      var t = n(0),
        r = n.n(t),
        t = n(1),
        n = n.n(t),
        t = function () {
          return r.a.createElement("g", {
            fill: "none"
          }, r.a.createElement("path", {
            fill: "#FDB927",
            d: "M21.718 11.056c0 5.81-4.739 10.55-10.549 10.55S.621 16.865.621 11.055C.62 5.246 5.359.508 11.169.508s10.549 4.738 10.549 10.548z"
          }), r.a.createElement("path", {
            d: "M3.159 17.938a10.434 10.434 0 0 0 7.954 3.667c3.215 0 6.036-1.41 7.954-3.667-.677.113-2.82.339-7.954.339-5.246-.056-7.334-.282-7.954-.339zm18.277-4.568a10.353 10.353 0 0 0-.056-5.02c-1.016-.001-4.344-.114-10.154-.114-5.867 0-9.195.056-10.267.113A10.353 10.353 0 0 0 .621 11c0 .79.112 1.636.282 2.37 1.24 0 6.148.112 10.38.112 4.286.056 9.025-.056 10.153-.113zm-2.369-9.308c-1.918-2.2-4.739-3.554-7.898-3.554S5.19 1.862 3.272 4.062c.733-.113 2.82-.283 7.897-.283 4.964 0 7.108.17 7.898.283z",
            fill: "#141006"
          }), r.a.createElement("path", {
            fill: "#141006",
            d: "M21.718 11.056c0 5.81-4.739 10.55-10.549 10.55S.621 16.865.621 11.055C.62 5.246 5.359.508 11.169.508s10.549 4.738 10.549 10.548zM11.169.226C5.19.226.34 5.076.34 11.056s4.85 10.831 10.83 10.831S22 17.036 22 11.057C22 5.076 17.149.225 11.17.225z"
          }));
        };
      t.svg = {
        viewBox: "0 0 22 22"
      };
      var o = n()(t);
    }
  }, o.c = i, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 678);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return c[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var c, i;
});